// extracted by mini-css-extract-plugin
export default {"container":"SS90K4","nameWrapper":"Db8Fr9","nameBoxText":"GCnsIj","tooltipWrapper":"FFwepm","roleIcons":"gQlGSC","roleIcon":"jQhQyu"};